 <template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter && panel_required" class="designeroption">
            <div class="radiooption stylesoption" v-if="!loading">
                <span>{{ title }} </span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Split Spindle:';
                }
            },
            component_id: {
                default(){
                    return 'hardware_handle_split_spindle';
                }
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            openingDirection: {
                default(){
                    return '';
                }
            },
            typeRange: {
                default(){
                    return 0;
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareHandle, this.slab, this.openingDirection, this.typeRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/handle-split-spindle?slab=' + this.slab + '&hardware_handle=' + this.hardwareHandle + '&opening_direction=' + this.openingDirection + '&type_range=' + this.typeRange;
            },
            cache_key(){
                return '_' + this.hardwareHandle + '_' + this.slab + '_' + this.openingDirection + '_' + this.typeRange;
            },
            panel_required(){
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
